module.exports = __webpack_public_path__ + "img/background-stripes.57831882.png";